export class Config {
    //public static server = 'https://api.shirtum.com';
    public static server = 'https://mdm.arkerlabs.com';
    //public static server = 'http://localhost:3000';
}
